import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    RECOMMENDED,
} from 'wanderu-ducks-search';
import { localize } from 'wanderu-i18n';

import styles from './FilterButton.scss';
import filterStyles from '../MobileFilters/MobileFilters.scss';

const FilterButton = (props) => {
    const {
        activeSortType = '',
        onSelectSortType,
        sortOptionData = '',
        t,
        type,
    } = props;
    const selectSortType = () => onSelectSortType?.(type);

    const detailsLabel = type === RECOMMENDED
        ? sortOptionData
        : t(`${type}_tag`);

    return (
        <button
            className={classNames(
                styles.container,
                filterStyles['filter-button'],
                {
                    [styles.active]: type === activeSortType,
                },
            )}
            data-id="sortOption"
            onClick={selectSortType}
        >
            <span className={filterStyles['sort-type']}>
                {t(`${type}_tag`)}
            </span>

            <span
                aria-label={detailsLabel}
                aria-live="polite"
                className={styles.details}
            >
                {sortOptionData}
            </span>
        </button>
    );
};

FilterButton.propTypes = {
    activeSortType: PropTypes.string,
    onSelectSortType: PropTypes.func,
    sortOptionData: PropTypes.string,
    t: PropTypes.func,
    type: PropTypes.string,
};

export { FilterButton };
export default localize(FilterButton, 'baseApp');
